import { ChangeDetectionStrategy, Component, inject, input, model, output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalService } from '@cfp/core';
import { InputSearch } from '@cfp/shared/ui/input-search';
import { Button, CfpTranslateModule } from '@cfp/ui';
import { TranslateModule } from '@ngx-translate/core';
import { TagsAddModal } from '../tags-add-modal';

@Component({
  selector: 'cfp-tags-toolbar',
  templateUrl: './tags-toolbar.html',
  imports: [InputSearch, Button, TranslateModule, CfpTranslateModule, FormsModule, ReactiveFormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TagsToolbar {
  public readonly searchText = model<string | undefined>(undefined);
  public readonly portfolioId = input.required<number>();
  public readonly fetchTags = output();

  private readonly modalService = inject(ModalService);

  protected openAddTagModal(): void {
    const bsModalRef = this.modalService.show(TagsAddModal, {
      initialState: {
        portfolioId: this.portfolioId()
      },
      class: 'modal-sm modal-dialog-centered'
    });

    if (bsModalRef.content) {
      bsModalRef.content.closeClicked.subscribe(() => this.fetchTags.emit());
    }
  }
}
